'use client'
import { Slider } from '@/core/ui/atoms/slider'
import { Category } from '@/features/categories/model/category.model'
import { CategoryItem } from '../category-item'
import { useLocale } from 'next-intl'

interface Props {
  categories: Category[]
}
export const CategoriesList: React.FC<Props> = ({ categories }) => {
  const locale = useLocale()
  const isRTL = locale === 'ar'
  return (
    <Slider
      slides={categories.map(category => (
        <div key={category.slug}>
          <CategoryItem category={category} />
        </div>
      ))}
      slidesPerView={3}
      showDots={false}
      showArrows={true}
      delay={4000}
      autoPlay
      className='sm:px-5'
      breakpoints={{
        445: 3,
        640: 4,
        768: 5,
        1024: 5,
        1280: 8,
      }}
      renderPrevArrow={scrollPrev => (
        <button
          onClick={scrollPrev}
          className='bg-cyan-blue absolute top-1/2 -left-10 z-10 hidden h-8 w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full text-lg text-white shadow-md sm:flex'
        >
          {isRTL ? '›' : '‹'}
        </button>
      )}
      renderNextArrow={scrollNext => (
        <button
          onClick={scrollNext}
          className='bg-cyan-blue absolute top-1/2 -right-10 z-10 hidden h-8 w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full text-lg text-white shadow-md sm:flex'
        >
          {isRTL ? '‹' : '›'}
        </button>
      )}
      renderDot={({ index, isActive, onClick }) => (
        <button
          key={index}
          onClick={onClick}
          className={`rtl h-3 w-3 cursor-pointer rounded-full transition-all ${
            isActive
              ? 'bg-creamed-cron'
              : 'bg-anti-flash border-creamed-cron border'
          }`}
        />
      )}
    />
  )
}
